import { Injectable, inject, signal } from "@angular/core";
import { finalize } from "rxjs";
import { LoadingService, OVERLAY_POSITION } from "src/app/shared/services/loading.service";
import { SystemStateService } from "../../system-state-widget/services/system-widget.service";
import { SystemStateModel, SystemState, SystemType } from "../models/system-state.model";


@Injectable({ providedIn: 'root' })
export class SystemStateWidgetStore {
  systemStateService = inject(SystemStateService);
  loadingService = inject(LoadingService);

  systemState = signal<SystemStateModel>({ state: SystemState.UNKNOWN });

  loadSystemState() {
    this.loadingService.show(OVERLAY_POSITION.COMPONENT);

    this.systemStateService
      .fetchSystemState() 
      .pipe(
        finalize(() => this.loadingService.hide(OVERLAY_POSITION.COMPONENT)),
      ).subscribe((systemStates) => {

        if(systemStates.find(state => state.state !== SystemState.ONLINE)) {
             if(systemStates.every(s => s.state === SystemState.OFFLINE)) {
                    this.systemState.set({ state: SystemState.OFFLINE, message: "Alle Systeme sind offline!" });
                    return;
                }
                if(systemStates.every(s => s.state === SystemState.MAINTENANCE)) {
                    this.systemState.set({state : SystemState.MAINTENANCE, message: "Alle Systeme befinden sich in Wartungsarbeiten!" });
                    return;
                }
            
                if(systemStates.find(state => state.state === SystemState.ONLINE))
                    this.systemState.set({ message: "", state: SystemState.PARTIAL_ONLINE });
                else
                    this.systemState.set({ message: "", state: SystemState.OFFLINE_OR_MAINTENANCE });
            systemStates.forEach(state => {
                
                if(state.state === SystemState.MAINTENANCE) {
                    this.systemState.update(prev => ({ ...prev, message: prev.message === "" ? "Wartungsarbeiten an der " + this.getSystemTypeLabel(state.systemType!) : prev.message + "\nWartungsarbeiten an der " + this.getSystemTypeLabel(state.systemType!)}));
                }   
                if(state.state === SystemState.OFFLINE) {
                    this.systemState.update(prev => ({ ...prev, message: prev.message === "" ? this.getSystemTypeLabel(state.systemType!) + " ist offline!" : prev.message + "\n" + this.getSystemTypeLabel(state.systemType!) + " ist offline!" }));
                }  
               
            })
        } else {
            this.systemState.set({ state: SystemState.ONLINE, message: 'Alle Systeme online, keine Störungen vorhanden' });
        }
        });
  }



  private getSystemTypeLabel(systemType: SystemType): string {
    switch (systemType) {
      case SystemType.NECTA_ONE:
        return 'necta.one-API';
      case SystemType.VENDOR_CATALOG:
        return 'necta.supply-API';
      default:
        return 'Unbekanntes System';
    }
}
}